module.exports = __webpack_public_path__ + "static/media/icon-snowflake.aa533113.svg";